<template>
  <div>
    <div v-if="values" style="margin-top: 20px;">
      <div class="onediv">
        <div class="leftdiv">
          <label class="labeltext">车牌</label>
          <label class="labelval">{{values.carNo}}</label>
        </div>
        <div class="leftdiv">
          <label class="labeltext">服务顾问</label>
          <label class="labelval">{{values.consultantName}}</label>
        </div>
      </div>
      <div class="onediv">
        <div class="leftdiv">
          <label class="labeltext">到厂时间</label>
          <label class="labelval">{{values.enterTime.split(' ')[0]}}</label>
        </div>
        <div class="leftdiv">
          <label class="labeltext">交车时间</label>
          <label class="labelval">{{values.estimateDeliveryTime.split(' ')[0]}}</label>
        </div>
      </div>
    </div>
    <div style="margin:20px 0px;">
        <div v-for="(item,index) in prolist" :key="item.id">
            <div style="display: flex;justify-content: center;align-items: center;">
                <div class="roundTextleft">{{item.name}}</div>
                <div class="bround" :style="getStyle(item.seq)">
                    <div class="sround">
                        <div v-if="item.seq===seqconst" style="text-align: center;line-height: 40px;">
                            <span v-if="values.progress<=100" style="font-size:14px;">{{values.progress || 0}}%</span>
                            <span v-else class="spanvalue" style="color:red;font-size:14px;">超时</span>
                        </div>
                    </div>
                </div>
                <div v-if="item.id===values.procedureId" class="roundTextright">{{values.technicianName}}</div>
            </div>
            <div class="iconArrow" v-if="prolist.length-1!=index" style="background-image: url(arrow.png);"></div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WxCarSearchDetailed',
  props: {
    values: Object,
    prolist: Array,
    seqconst: Number
  },
  data () {
    return {

    }
  },
  methods: {
    getStyle (seq) {
        if (seq < this.seqconst) {
             return 'background:#4BED0C'
        } else if (seq > this.seqconst) {
             return 'background:#D8D8D8'
        } else {
            return 'background:#3662EC'
        }
    }
  }
}
</script>

<style lang="scss" scoped>
.onediv {
  display: flex;
  height: 40px;
  line-height: 40px;
}
.leftdiv {
  display: flex;
  width: 50%;
}

.labeltext {
  flex: 0.7;
  margin-right: 15px;
  text-align: right;
}

.labelval {
  flex: 1;
}
.bround {
  width: 60px;
  height: 60px;
  background: white;
  box-sizing: border-box;
  border: 1px solid #000000;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sround {
  width: 40px;
  height: 40px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #000000;
  border-radius: 50%;
}
.iconArrow{
    width: 64px;
    height: 64px;
    margin: 0px auto;
}
.roundTextleft{
position: absolute;
left: 25%;
}
.roundTextright{
position: absolute;
right: 25%;
}
</style>
